import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LazyLoadMeta } from 'primeng/api';
import { QueryModel } from '../models/query.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    protected http: HttpClient,
  ) { }

  getPaginationQuery(event: LazyLoadMeta, query: any = null): any {
    if (!query) {
      query = new QueryModel(0, 10);
    }

    query.pageSize = event?.rows || 10;
    query.pageOffset = event?.first! > 0 ? (event?.first! / query.pageSize) : 0;
    query.sortBy = event?.sortField || 'id';
    query.sortOrder = (event?.sortOrder && event?.sortOrder < 0) ? 'asc' : 'desc';
    return query;
  }

  toQueryString(obj: any) {
    let parts = [];
    for (const property in obj) {
      const value = obj[property];
      if (value != null && value !== undefined) {
        parts.push(encodeURIComponent(property) + '=' + encodeURIComponent(value));
      }
    }

    return parts.join('&');
  }
}
